import React from "react";

const MessageBox = ({ message, onClose, isOpen }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[#fafaf8]/90 backdrop-blur-sm flex items-center justify-center z-50 px-6">
      <div className="bg-white border border-[#e8e8e4] rounded-none shadow-none p-12 max-w-md w-full text-center">
        <p className="text-sm tracking-[0.2em] uppercase text-[#E78730] mb-6">
          Notice
        </p>

        <h3 className="font-serif text-2xl text-[#1a1a1a] leading-snug mb-10">
          {message}
        </h3>

        <button
          onClick={onClose}
          className="bg-[#E78730] hover:opacity-80 text-white text-xs tracking-[0.18em] uppercase font-medium py-3 px-12 transition-opacity duration-200"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default MessageBox;
